import React from 'react';
import styled from 'styled-components';
import { UnstyledButton } from '.';
import { Icon } from '../Icon';
const StyledIcon = styled(Icon) `
  color: ${({ theme }) => theme.primaryBlack};
  font-size: 45px;
`;
// TODO: move to Nav Folder or Buttons
export const NavMenuButton = ({ isMenuOpen, setOpen }) => {
    const toggleMenu = () => setOpen(!isMenuOpen);
    return (React.createElement(UnstyledButton, { onClick: toggleMenu }, isMenuOpen ? (
    // TODO: get aria-label from sitecore backend
    React.createElement(StyledIcon, null, "close")) : (
    // TODO: get aria-label from sitecore backend
    React.createElement(StyledIcon, null, "menu"))));
};
